(function() {
  var PAGE_SIZE = 12;

  var grid = document.querySelector('[data-features-grid]');
  var moreBtn = document.querySelector('[data-features-more]');
  if (!grid || !moreBtn) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('[data-features-item]'));
  var visibleCount = 0;

  function updateVisibility() {
    items.forEach(function(item, index) {
      if (index < visibleCount) {
        item.removeAttribute('hidden');
      } else {
        item.setAttribute('hidden', '');
      }
    });

    if (visibleCount >= items.length) {
      moreBtn.setAttribute('hidden', '');
    } else {
      moreBtn.removeAttribute('hidden');
    }
  }

  if (items.length <= PAGE_SIZE) {
    visibleCount = items.length;
  } else {
    visibleCount = PAGE_SIZE;
  }
  updateVisibility();

  moreBtn.addEventListener('click', function() {
    visibleCount += PAGE_SIZE;
    updateVisibility();
  });
})();
